import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';


function init (element) {
    $(element).each(function () {
        const $this = $(this);
        const $container = $this.find('[data-tooltip-container]');
        const params = $this.data('tooltip');
        const content = params.content || $container.get(0).innerHTML;
        const customOptions = params.options || {};

        if (content) {
            const options = Object.assign({
                allowHTML: true,
                content: content,
                placement: 'top',
                arrow: true,
                interactive: true,
                animation: 'scale',
                appendTo:$this.get(0)
            }, customOptions);

            tippy($this.get(0), options);
        }
    });
}

export default function (element) {
    init(element);
}